import React from "react";

const Footer = () => (
  <footer className="bg-pinky2 text-pinky5 text-center py-6 mt-12 rounded-t-2xl shadow-inner animate-fade-in">
    &copy; {new Date().getFullYear()} skand088. All rights reserved.
  </footer>
);

export default Footer;
